import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que recibe una cadena de texto representando una hora en formato 24
 * y los trasformar a formato 12/24
 */
@Pipe({name: 'time_am_pm'})
export class FormatTimePipe implements PipeTransform {
  transform(value: string): string {
    const index = value.indexOf(':');
    const hour = value.slice(0, index);
    const minute = value.slice(index+1);
    let numberHour = Number(hour);
    let indicator: string;
    if (numberHour > 11 ) {
      indicator = 'p.m.';
      if (numberHour > 12) {
        numberHour -= 12;
      }
    } else {
      indicator = 'a.m.';
    }
    const transformedHour = numberHour < 10 ? `0${numberHour}` : numberHour.toString();
    return `${transformedHour}:${minute} ${indicator}`;
  }
}